import { tour } from '../../walkthroughs/service'
import * as drsModule from '@/store/modules/drs/drs.module'
import { VALID_DATA_STATUS, MAPPING_STATUS } from '@/components/drs/service/location-mapping.mixin'
import { TIMELINES } from '@/utils/constants/drs/tariffs'
import router from '../../router'
import moment from 'moment'

const { TEST_SERVICE_CODE: DRS_TEST_CODE } = drsModule
export const UNSUPPORTED_SERVICE_CODES = [DRS_TEST_CODE]

export const services = {
    state: {
        status: 'idle',
        serviceStatus: 'idle',
        services: [],
        service: {},
        servicesWithCustomAction: {
            // serviceCode:{link:String}
            sgnk: {
                link: process.env.VUE_APP_CASH_AMOUNT_SERVICE_URL
            }
        },
        walkthroughServiceCode: null,
        drsData: null,
        drsLocationMappings: {},
        drsLocationMappingResults: {},
        kplCompany: null
    },
    mutations: {
        SET_SERVICES_STATUS(state, payload) {
            state.status = payload
        },
        SET_SERVICE_STATUS(state, payload) {
            state.serviceStatus = payload
        },
        SET_SERVICES(state, payload) {
            state.services = payload
        },
        SET_SERVICE(state, payload) {
            state.service = payload
        },
        SET_WALKTHROUGH_SERVICE_CODE(state, payload) {
            state.walkthroughServiceCode = payload
        },
        SET_DRS_DATA(state, payload) {
            state.drsData = payload
        },
        SET_DRS_LOCATION_MAPPINGS(state, payload) {
            state.drsLocationMappings = payload
        },
        SET_DRS_LOCATION_MAPPING_RESULTS(state, results) {
            state.drsLocationMappingResults = results
        },
        RESET_DRS_LOCATION_MAPPING_STATE(state) {
            state.drsLocationMappings = {}
            state.drsLocationMappingResults = {}
        },
        SET_KPL_COMPANY(state, payload) {
            state.kplCompany = payload
        }
    },
    actions: {
        servicesFetch({ commit, getters }) {
            commit('SET_SERVICES_STATUS', 'loading')
            const userId = getters.userId
            const requestUrl = `subscriptions_services/${userId}/services/`
            return this.$api
                .get(requestUrl)
                .then(response => {
                    const services = response.data.data.services
                    commit('SET_SERVICES', services)
                    commit('SET_SERVICES_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_SERVICES_STATUS', 'idle')
                    }
                })
        },
        async serviceFetch({ commit, getters }, payload) {
            try {
                commit('SET_SERVICE_STATUS', 'loading')
                const userId = getters.userId
                const { data, status } = await this.$api.get(
                    `subscriptions_services/${userId}/services/${payload}`,
                    {
                        params: {
                            subscriptionsWithEntityData: true
                        }
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error serviceFetch')
                }

                const setSubscriptionsData = data.data
                setSubscriptionsData.subscriptions = setSubscriptionsData.subscriptions.map(
                    el => {
                        return {
                            ...el,
                            checked: el.status === 'active'
                        }
                    }
                )
                commit('SET_SERVICE', setSubscriptionsData)
            } catch(err) {
                console.log(err)
            } finally{
                commit('SET_SERVICE_STATUS', 'idle')
            }
        },
        setService({ commit }, payload) {
            commit('SET_SERVICE', payload)
        },
        selectServiceShop({ state, commit }, shopId) {
            const service = state.service
            for (const shop of service.subscriptions) {
                if (shop.entityData.id === shopId && shop.status === 'inactive') {
                    shop.checked = !shop.checked
                }
            }
            commit('SET_SERVICE', service)
        },
        async sendServiceActivateRequest({ getters }, payload) {
            const userId = getters.userId
            let params
            if (payload.level === 'User' || payload.level === 'Company') {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: [userId]
                }
            } else {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: payload.shopIds
                }
            }

            return await this.$api.patch(
                `subscriptions_services_on_off/users/${userId}/services/${payload.serviceId}/activate`,
                params
            )
        },
        async serviceActivate({ dispatch }, payload) {
            const res = await dispatch('sendServiceActivateRequest', payload)
            dispatch('toggleModal', false)
            if (res.status === 200) {
                if (payload.singleService) {
                    dispatch('serviceFetch', payload.serviceId)
                } else {
                    dispatch('servicesFetch')
                }
                await dispatch('setWalkthroughServiceCode', payload.serviceCode)
                tour.start()
                return dispatch('addNotification', {
                    type: 'success',
                    content: payload.allShops
                        ? 'Pomyślnie włączono usługę. Dostęp do usługi / promocji zostanie udzielony w przeciągu kilku minut.'
                        : 'Usługa została aktywowana w wybranych sklepach'
                })
            } else {
                return dispatch('addNotification', {
                    type: 'danger',
                    content:
                        'Nie udało się aktywować usługi we wskazanych sklepach. Skontaktuj się z naszym Helpdeskiem pod numerem 22 12 91 400'
                })
            }
        },
        serviceDeactivate({ getters, dispatch }, payload) {
            const userId = getters.userId
            let params
            if (payload.level === 'User' || payload.level === 'Company') {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: [userId]
                }
            } else {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: payload.shopIds
                }
            }
            this.$api
                .patch(
                    `subscriptions_services_on_off/users/${userId}/services/${payload.serviceId}/deactivate`,
                    params
                )
                .then(res => {
                    dispatch('toggleModal', false)
                    if (res.status === 200) {
                        if (payload.singleService) {
                            dispatch('serviceFetch', payload.serviceId)
                        } else {
                            dispatch('servicesFetch')
                        }
                        if (res.data.data.errors.length > 0) {
                            dispatch('addNotification', {
                                type: 'danger',
                                content: res.data.data.errors[0].message
                            })
                        } else {
                            dispatch('addNotification', {
                                type: 'success',
                                content: 'Usługa została wyłączona'
                            })
                        }
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                    }
                })
                .catch(err => console.log(err))
        },
        setWalkthroughServiceCode({ commit }, payload) {
            commit('SET_WALKTHROUGH_SERVICE_CODE', payload)
        },

        async fetchDrsLocations({ getters, commit }) {
            try {
                const { status, data } = await this.$api.get(
                    `users/${getters.userId}/drs/companies?nips=${getters.getUserCompanies[0].nip}`
                )

                if (status !== 200) {
                    throw new Error('Failed fetchDrsCompanies')
                }

                const drsCompanies = data.data?.companies

                commit('SET_DRS_DATA', {
                    login: drsCompanies[0]?.login,
                    locations: drsCompanies[0]?.locations || []
                })
            } catch (error) {
                console.error(error)
                commit('SET_DRS_DATA', {
                    login: null,
                    locations: []
                })
            }
        },

        saveDrsLocationMappings({ commit }, mappings) {
            commit('SET_DRS_LOCATION_MAPPINGS', mappings)
        },

        resetDrsLocationMappingState({ commit }) {
            commit('RESET_DRS_LOCATION_MAPPING_STATE')
        },

        async mapDrsLocations({ getters, commit }) {
            const mappings = getters.drsLocationMappings || {}
            const replicatedLocations = getters.replicatedLocationsByEpId
            const results = {}

            for (const { id: epShopId } of getters.locationsToActivate) {
                const replicatedLocation = replicatedLocations[epShopId]
                const kplShopId = mappings[epShopId]

                if (replicatedLocation) {
                    results[epShopId] = {
                        status: MAPPING_STATUS.REPLICATED,
                        epShopId,
                        kplShopId: replicatedLocation.id
                    }
                    continue
                }

                // Skip locations mapped to a yearly KPL tariff
                if (getters.yearlyTariffLocationIds.includes(+kplShopId)) {
                    results[epShopId] = {
                        status: MAPPING_STATUS.ERROR,
                        epShopId,
                        kplShopId
                    }
                    continue
                }

                // If no KPL location selected, set NEW result status
                if (!kplShopId || kplShopId === VALID_DATA_STATUS.NONE) {
                    results[epShopId] = {
                        status: MAPPING_STATUS.NEW,
                        epShopId,
                        kplShopId: null
                    }

                    continue
                }

                try {
                    // Map EP location with existing KPL location
                    const { status } = await this.$api.post(
                        'locations/drs/replication/mapping/update',
                        {
                            local_location_id: Number(epShopId),
                            ext_location_id: Number(kplShopId)
                        }
                    )

                    if (status !== 200) {
                        throw new Error(`Error mapDrsLocations for location ${epShopId}`)
                    }

                    results[epShopId] = {
                        status: MAPPING_STATUS.MAPPED,
                        epShopId,
                        kplShopId
                    }
                } catch (error) {
                    console.error(error)

                    results[epShopId] = {
                        status: MAPPING_STATUS.ERROR,
                        epShopId,
                        kplShopId
                    }
                }
            }

            // Save mapping results
            commit('SET_DRS_LOCATION_MAPPING_RESULTS', results)
        },

        async activateDrsService({ dispatch }, payload) {
            try {
                const { status, data } = await dispatch('sendServiceActivateRequest', payload)

                if (status !== 200) {
                    throw new Error(data.message || 'Failed to activate drs service')
                }

                await dispatch('replicateDrsLocations', { shopIds: payload.shopIds })
            } catch (error) {
                console.error(error)
            }
        },

        async replicateDrsLocations(_, { shopIds } = {}) {
            const failedShopIds = []

            for (const shopId of shopIds || []) {
                try {
                    const response = await this.$api.post('locations/drs/replication/force?locationsId=' + shopId)

                    if (!response || response.status !== 200) {
                        throw new Error('Błąd replikacji DRS dla sklepu ' + shopId)
                    }
                } catch (error) {
                    failedShopIds.push(shopId)
                }
            }

            if (failedShopIds.length) {
                throw new Error('Błąd replikacji DRS dla sklepów: ' + failedShopIds.join(', '))
            }
        },

        async updateMappedLocationsSubscriptions({ getters, rootGetters, dispatch }) {
            const mappingResults = getters.drsLocationMappingResults || {}
            const mappings = getters.drsLocationMappings || {}

            const mappedEpShopIds = Object.entries(mappingResults)
                .filter(([, result]) => result.status === MAPPING_STATUS.MAPPED)
                .map(([epShopId]) => epShopId)

            // Skip if there are no mapped locations
            if (!mappedEpShopIds.length) {
                return {
                    tariff: null,
                    locations: [],
                    authorizationPaymentUrl: null
                }
            }

            // Load drs locations data
            await dispatch('drs/fetchLocationsWithCompanyId', null, { root: true })

            // Load tariffs if missing
            if (!rootGetters['drsTariffs/tariffs'].length) {
                await dispatch('drsTariffs/loadDrsTariffs', null, { root: true })
            }

            // Load subscriptions before processing
            const kplSubscriptions = await dispatch('loadKPLSubscriptions')

            // Mapped subscriptions must use the monthly tariff
            const targetTariff = rootGetters['drsTariffs/tariffs'].find(
                tariff => tariff.timeline === TIMELINES.MONTHLY
            )

            if (!targetTariff?.id) {
                throw new Error('Missing target DRS tariff')
            }

            const updatedLocations = []

            for (const epShopId of mappedEpShopIds) {
                const kplShopId = mappings[epShopId]

                if (!kplShopId || kplShopId === VALID_DATA_STATUS.NONE) {
                    continue
                }

                try {
                    const locationSubscriptions = kplSubscriptions.find(sub => sub.bo_location_id === kplShopId)

                    const currentSubscription = locationSubscriptions?.current || null
                    const expiringSubscription = locationSubscriptions?.expiring || null

                    let subscription = currentSubscription

                    // Use expiring subscription only if current does not exist and expiring is still valid
                    if (!subscription && expiringSubscription) {
                        if (expiringSubscription.date_to) {
                            const today = moment()
                            const subscriptionEndDate = moment(expiringSubscription.date_to)

                            if (!today.isAfter(subscriptionEndDate)) {
                                subscription = expiringSubscription
                            }
                        }
                    }

                    // Skip if there is no current or valid expiring subscription
                    if (!subscription) {
                        continue
                    }

                    // Skip if the subscription already uses the target tariff
                    if (subscription.tariff_id === targetTariff.id) {
                        continue
                    }

                    const subscriptionData = await dispatch('prepareMappedLocationSubscription', {
                        subscription
                    })

                    const location = rootGetters['drs/getLocations'].find(
                        ({ id }) => id === kplShopId
                    )

                    if (!location) {
                        console.error(`Missing DRS location ${kplShopId} after subscription update`)
                        continue
                    }

                    updatedLocations.push({
                        epShopId,
                        kplShopId,
                        location,
                        ...subscriptionData
                    })
                } catch (error) {
                    console.error(error)
                }
            }

            if (!updatedLocations.length) {
                return {
                    tariff: targetTariff,
                    locations: [],
                    authorizationPaymentUrl: null
                }
            }

            const payload = {
                nip: rootGetters['drs/nip'],
                payment_type: rootGetters['drsTariffs/selectedPaymentType'],
                return_url: window.location.origin + router.resolve({
                    name: 'drs',
                    query: { paymentReturn: 'true' }
                }).href,
                payment_description: 'Płatność za subskrypcję w serwisie Kaucyjni.pl',
                locations: updatedLocations.map(({ kplShopId, deviceTypeSubscriptions }) => ({
                    bo_location_id: kplShopId,
                    coupon_code: null,
                    tariff_id: targetTariff.id,
                    price: null,
                    device_type_subscriptions: deviceTypeSubscriptions
                })),
                user: {
                    email: rootGetters['drsTariffs/invoiceEmail'] || getters.getUser?.email
                }
            }

            try {
                const { status, data } = await this.$api.post('drs/api/proxy/zor/v2/subscriptions', payload, {
                    params: {
                        service_code: 'KEC'
                    }
                })

                if (status < 200 || status >= 300) {
                    throw new Error('Failed to update subscriptions for mapped locations')
                }

                return {
                    tariff: targetTariff,
                    locations: updatedLocations,
                    authorizationPaymentUrl: data?.transaction_type === 'authorization'
                        ? data?.payment_url
                        : null
                }
            } catch (error) {
                console.error(error)

                return {
                    tariff: targetTariff,
                    locations: [],
                    authorizationPaymentUrl: null
                }
            }
        },

        async prepareMappedSubscriptionsSummary({ dispatch }) {
            const updatedSubscriptions = await dispatch('updateMappedLocationsSubscriptions')
            const hasMappedSubscriptionChanges = updatedSubscriptions.locations.length > 0

            if (hasMappedSubscriptionChanges) {
                await dispatch(
                    'drsTariffs/updateSelectedTariff',
                    updatedSubscriptions,
                    { root: true }
                )
            }

            return {
                hasMappedSubscriptionChanges,
                authorizationPaymentUrl: updatedSubscriptions.authorizationPaymentUrl
            }
        },

        async loadKPLSubscriptions({ rootGetters }) {
            try {
                const { data, status } = await this.$api.get(
                    'drs/api/proxy/zor/subscriptions',
                    {
                        params: {
                            nip: rootGetters['drs/nip'],
                            service_code: 'KPL'
                        }
                    }
                )

                if (status !== 200 || !data?.length) {
                    throw new Error('Failed to load KPL subscriptions')
                }

                return data.map(sub => {
                    const currentSubscription = sub.current_subscription
                    const expiringSubscription = sub.expiring_subscription

                    return {
                        ...sub,
                        current: Array.isArray(currentSubscription) ? null : currentSubscription,
                        expiring: Array.isArray(expiringSubscription) ? null : expiringSubscription
                    }
                })
            } catch (error) {
                console.error(error)
                return []
            }
        },

        prepareMappedLocationSubscription(_, { subscription }) {
            const hasAdditionalDevices = subscription.device_type_subscriptions?.some(device => {
                return device.device_type === 'ecr' && Number(device.amount) > 1
            })

            return {
                additionalDevices: hasAdditionalDevices,
                deviceTypeSubscriptions: [
                    {
                        code: 'ecr',
                        amount: hasAdditionalDevices ? 100 : 1
                    },
                    {
                        code: 'rvm',
                        amount: hasAdditionalDevices ? 10 : 0
                    },
                    {
                        code: 'md',
                        amount: 100
                    }
                ]
            }
        },

        async fetchKplCompany({ getters, commit }) {
            try {
                const nip = getters.getUserCompanies[0].nip
                if (!nip) return

                const { data, status } = await this.$api.get(
                    `drs/api/proxy/zor/companies/${nip}`,
                    {
                        params: {
                            service_code: 'KPL'
                        }
                    }
                )

                if (status !== 200 || !data) {
                    throw new Error('Failed to load KPL company data')
                }

                commit('SET_KPL_COMPANY', data.company)
            } catch (error) {
                console.error(error)
            }
        }
    },
    getters: {
        getServicesWithCustomAction: state => {
            return state.servicesWithCustomAction
        },
        getServices: state => {
            const services = state.services || []

            // Skip unsupported services
            return services.filter(service => !UNSUPPORTED_SERVICE_CODES.includes(service.code))
        },
        getActiveServices: (state, getters) => {
            return getters.getServices.filter(service => service.number_of_entities_with_subscription > 0)
        },
        getAvailableServices: (state, getters) => {
            return getters.getServices.filter(service =>
                service.number_of_entities_with_subscription < service.number_of_total_user_entities)
        },
        getServicesStatus: state => {
            return state.status
        },
        getServiceStatus: state => {
            return state.serviceStatus
        },
        getService: state => {
            return state.service
        },
        getServiceShops: state => {
            return state.service?.subscriptions || []
        },
        getToActiveServiceShopIds: (state, getters) => {
            return getters.getServiceShops
                .filter(el => el.status === 'inactive' && el.checked)
                .map(el => el.entityData.id)
        },
        getAllServiceShopIds: (state, getters) => {
            return getters.getServiceShops
                .filter(el => el.status !== 'not_allowed')
                .map(el => el.entityData && el.entityData.id)
        },
        getServiceById: state => id => {
            return state.services.find(el => el.id === id)
        },
        getServiceByCode: state => code => {
            return state.services.find(el => el.code === code)
        },
        getWalkthroughServiceCode: state => {
            return state.walkthroughServiceCode
        },
        isServiceActive: (_, getters) => code => {
            const shopTagService = getters.getServiceByCode(code)
            return (
                shopTagService &&
                shopTagService.number_of_entities_with_subscription > 0
            )
        },

        drsData: state => state.drsData,

        isDrsLoginMatched: (state, getters) => state.drsData?.login === getters.getUser?.email,

        unMappedDrsLocations: state => {
            return ((state.drsData || {}).locations || []).filter(loc => {
                const isActive = loc.state_code === 'ACTIVE'
                const isExist = loc.name !== '[NO_DATA]'
                const isUnMapped = !loc.mapped_data || loc.mapped_data.state !== 'ACTIVE'

                return isActive && isExist && isUnMapped
            })
        },

        replicatedLocationsByEpId: state => {
            return ((state.drsData || {}).locations || []).reduce((locations, loc) => {
                const epId = loc.mapped_data?.ep_id
                const isReplicated = loc.mapped_data?.state === 'ACTIVE' && epId != null

                if (isReplicated) {
                    locations[epId] = loc
                }

                return locations
            }, {})
        },

        yearlyTariffLocationIds: state => {
            return (state.kplCompany?.locations || [])
                .filter(loc => loc.active_tariff_timeline === TIMELINES.YEARLY)
                .map(loc => +loc.bo_location_id)
        },

        activatableDrsLocationIds: (_, getters) => (locationIds) => {
            const mappings = getters.drsLocationMappings || {}
            const replicatedLocations = getters.replicatedLocationsByEpId
            const yearlyLocationIds = getters.yearlyTariffLocationIds
            const epShopIds = Array.isArray(locationIds)
                ? locationIds
                : getters.locationsToActivate.map(({ id }) => id)

            return epShopIds.filter(epShopId => {
                // Replicated locations are always activated
                if (replicatedLocations[epShopId]) {
                    return true
                }

                return !yearlyLocationIds.includes(+mappings[epShopId])
            })
        },

        isDrsServiceAvailable: (_, getters) => {
            // Multi nip users are not allowed
            return !getters.isMultiNip
        },

        locationsToActivate: (_, getters) => {
            return getters.getServiceShops
                .filter(loc => loc.status === 'inactive' && loc.checked)
                .map(loc => {
                    const id = loc.entityData.id
                    const address = getters.getUserLocationById(id)?.address

                    return {
                        ...loc,
                        id,
                        address,
                        name: loc.entityData.name
                    }
                })
        },

        drsLocationMappings: state => state.drsLocationMappings,
        drsLocationMappingResults: state => state.drsLocationMappingResults,
        isKplCompanyDebt: state => !!state.kplCompany?.debt
    }
}